window.getLangHi = function() {
  return {
    meta_description: 'Ezeful आसान, उपयोगी और मुफ़्त टूल है।',
    detailed_description: '',
    validation: {
      audio: ':attribute एक ऑडियो होनी चाहिए।',
      audio_or_video: ':attribute ऑडियो या वीडियो होनी चाहिए।',
      image: ':attribute एक छवि होनी चाहिए।',
      video: ':attribute एक वीडियो होना चाहिए।',
      unknown: 'प्रसंस्करण विफल। कृपया अपना इनपुट जांचें।',
      no_input: 'कोई इनपुट फ़ाइल निर्दिष्ट नहीं की गई।',
    },
    label: {
      input: 'इनपुट',
      output: 'उत्पादन',
      target: 'लक्ष्य',
      result: 'परिणाम',
      source_file: 'स्रोत फ़ाइल',
      source_format: 'स्रोत प्रारूप',
      source_charset: 'स्रोत चरित्र सेट',
      source_encoding: 'स्रोत एन्कोडिंग',
      destination_format: 'गंतव्य प्रारूप',
      destination_charset: 'गंतव्य चरित्र सेट',
      destination_encoding: 'गंतव्य एन्कोडिंग',
      execute: 'दौड़ना',
      download: 'डाउनलोड',
      to_json: 'JSON करने के लिए',
      to_yaml: 'YAML करने के लिए',
      to_toml: 'TOML करने के लिए',
      to_csv: 'CSV करने के लिए',
      to_xml: 'XML करने के लिए',
      delimiter: 'सीमांकक',
      indent: 'इंडेंट',
      space: 'स्पेस',
      transform: 'परिवर्तन',
      convert: 'धर्मांतरित',
      beautify: 'सुंदर बनाएं',
      minify: 'छोटा करना',
      generate: 'सृजन करना',
      copy: 'प्रतिलिपि',
      open: 'खुली',
      close: 'बंद करें',
      auto: 'ऑटो',
      number: 'संख्या',
      length: 'लंबाई',
      regex: 'नियमित अभिव्यक्ति',
      sample: 'नमूना',
      option: 'विकल्प',
      flag: 'खण्ड',
      quality: 'गुणवत्ता',
      preview: 'पूर्वावलोकन',
      add_effect: 'प्रभाव जोड़ें',
      previous: 'पिछला',
      next: 'अगला',
      encoder: 'एनकोडर',
      size: 'आकार',
      bit_rate: 'बिट दर',
      sampling_rate: 'नमूनाकरण दर',
      frame_rate: 'फ्रेम रेट',
      not_specified: 'निर्दिष्ट नहीं है',
      not_change: 'कोई परिवर्तन नहीं होता है',
      auto_download: 'स्वचालित डाउनलोड',
      advanced_setting: 'उन्नत व्यवस्था',
    },
    hint: {
      select: 'कृपया चुने।'
    },
    placeholder: {
      json: 'कृपया यहां JSON प्रारूप में दर्ज करें।',
      yaml: 'कृपया यहां YAML प्रारूप में दर्ज करें।',
      toml: 'कृपया यहां TOML प्रारूप में दर्ज करें।',
      xml: 'कृपया यहां XML प्रारूप में दर्ज करें।',
      csv: 'कृपया यहां CSV प्रारूप में दर्ज करें।',
      regex: 'कृपया यहां रेगुलर एक्सप्रेशन दर्ज करें।',
      text: 'कृपया यहां पाठ दर्ज करें।',
      string: 'कृपया यहां स्ट्रिंग दर्ज करें।',
    },
    alert: {
      result: 'परिणाम यहां प्रदर्शित किए गए हैं।',
      copied: 'इसे क्लिपबोर्ड पर कॉपी किया गया था।',
    },
    attribute: {
      json: 'JSON',
      yaml: 'YAML',
      toml: 'TOML',
      xml: 'XML',
      csv: 'CSV',
      audio: 'ऑडियो',
      video: 'वीडियो',
      image: 'छवि'
    },
    class: {
      multimedia: {
        name: 'मल्टीमीडिया',
      },
      text: {
        name: 'इबारत',
      },
      others: {
        name: 'अन्य'
      },
      language: {
        name: 'भाषा'
      },
    },
    application: {
      contact: {
        name: 'संपर्क'
      },
      privacy_policy: {
        name: 'गोपनीयता नीति',
        meta_description: 'जब आप सेवा का उपयोग करते हैं तो यह गोपनीयता नीति आपकी जानकारी के संग्रह, उपयोग और प्रकटीकरण पर हमारी नीतियों और प्रक्रियाओं का वर्णन करती है और आपको आपके गोपनीयता अधिकारों के बारे में बताती है और कानून आपकी सुरक्षा कैसे करता है। हम इस गोपनीयता नीति में वर्णित के अलावा आपकी जानकारी का उपयोग या किसी के साथ साझा नहीं करेंगे।',
        detailed_description: 'जब आप सेवा का उपयोग करते हैं तो यह गोपनीयता नीति आपकी जानकारी के संग्रह, उपयोग और प्रकटीकरण पर हमारी नीतियों और प्रक्रियाओं का वर्णन करती है और आपको आपके गोपनीयता अधिकारों के बारे में बताती है और कानून आपकी सुरक्षा कैसे करता है। हम इस गोपनीयता नीति में वर्णित के अलावा आपकी जानकारी का उपयोग या किसी के साथ साझा नहीं करेंगे।',
        label: {
          about_analytics: {
            name:'एक्सेस विश्लेषण टूल के बारे में',
            description: 'यह साइट Google के एक्सेस विश्लेषण टूल, Google Analytics का उपयोग करती है।<br><br>Google Analytics ट्रैफ़िक डेटा एकत्र करने के लिए कुकीज़ का उपयोग करता है। यह ट्रैफ़िक डेटा गुमनाम रूप से एकत्र किया गया है और किसी व्यक्ति की पहचान नहीं करता है। <br><br>Google Analytics कुकी को 26 महीने तक बनाए रखा जाता है. यह सुविधा आपको कुकीज़ को अक्षम करके संग्रह को अस्वीकार करने की अनुमति देती है, इसलिए अपनी ब्राउज़र सेटिंग जांचें।<br><br>यदि आप Google Analytics के उपयोग की शर्तों की जांच करना चाहते हैं, तो कृपया <a href="https://www.google.com/analytics/terms/us.html" target="_blank">https://www.google.com/analytics/terms/us.html</a> पर जाएं।<br>भी , यदि आप "Google के डेटा के उपयोग के बारे में जानना चाहते हैं जब उपयोगकर्ता Google भागीदार साइटों और ऐप्स का उपयोग करते हैं," तो <a href="https://policies.google.com/technologies/partner-sites?hl=hi" target="_blank">https://policies.google.com/technologies/partner-sites?hl=hi</a> पर जाएं। मुझे दो।'
          },
          about_advertisement: {
            name:'तृतीय-पक्ष विज्ञापन सेवाओं के बारे में',
            //description: 'यह साइट तृतीय-पक्ष विज्ञापन सेवा "Google Adsense" का उपयोग करती है।<br><br>तीसरे पक्ष के विज्ञापन वितरक, जैसे कि Google, आगंतुकों की रुचि के अनुसार विज्ञापन प्रदर्शित करने के लिए कुकीज़ का उपयोग करते हैं (जैसे कि इस साइट पर आने वाले विज़िटर द्वारा इस साइट या अन्य साइटों तक पहुंचने पर जानकारी)।<br><br>विज़िटर विज्ञापन सेटिंग में विज़िटर-विशिष्ट विज्ञापनों (बाद में "व्यक्तिगत विज्ञापन" के रूप में संदर्भित) को अक्षम कर सकते हैं।<br>ऐसा करने के लिए, <a href="https://www.google.com/settings/ads" target="_blank">https://www.google.com/settings/ads</a> पर जाएं।<br>आप <a href="https://www.aboutads.info" target="_blank">https://www.aboutads.info</a> पर जाकर वैयक्तिकृत विज्ञापन के लिए उपयोग की जाने वाली तृतीय-पक्ष प्रकाशक कुकी को अक्षम भी कर सकते हैं।<br><br>यदि आपने तृतीय-पक्ष विज्ञापन प्लेसमेंट को अक्षम नहीं किया है, तो तृतीय-पक्ष वितरकों और विज्ञापन नेटवर्क के विज्ञापन आपकी साइट पर प्रदर्शित हो सकते हैं।<br><br>विज्ञापन वितरकों के बारे में अधिक जानकारी के लिए जिन्हें Google द्वारा तृतीय पक्षों को विज्ञापन देने की अनुमति है, कृपया <a href="https://support.google.com/dfp_premium/answer/94149" target="_blank">https://support.google.com/dfp_premium/answer/94149</a> पर जाएं।'
            description: 'यह साइट तृतीय-पक्ष विज्ञापन सेवा का उपयोग करती है।<br><br>तृतीय-पक्ष विज्ञापन वितरक आगंतुकों के हितों के अनुसार विज्ञापन प्रदर्शित करने के लिए कुकीज़ का उपयोग करते हैं (जैसे कि जब इस साइट पर आने वाले लोग इस साइट या अन्य साइटों तक पहुंचते हैं)।<br><br>आप अपनी ब्राउज़र सेटिंग से कुकी को हटा या अक्षम कर सकते हैं।<br>विवरण के लिए कृपया अपने ब्राउज़र की सहायता देखें।'
          },
          purpose_personal_information: {
            name:'व्यक्तिगत जानकारी के उपयोग का उद्देश्य',
            description: 'जब मैं ई-मेल द्वारा पूछताछ करता हूं तो यह साइट व्यक्तिगत जानकारी जैसे नाम (हैंडल नाम) और एक ईमेल पता जमा करने के लिए कह सकती है।<br><br>इन व्यक्तिगत जानकारी का उपयोग प्रश्नों के उत्तर देने और ई- मेल, आदि, और ऐसी व्यक्तिगत जानकारी का उपयोग ऐसे उद्देश्यों से परे किसी भी उद्देश्य के लिए नहीं किया जाएगा।'
          },
          disclosure_personal_information: {
            name:'तीसरे पक्ष को व्यक्तिगत जानकारी का खुलासा',
            description: 'इस साइट में, व्यक्तिगत जानकारी को उचित रूप से प्रबंधित किया जाता है, और इसे नीचे दिए गए मामले को छोड़कर तीसरे व्यक्ति को प्रकट नहीं किया जाएगा।<br><br>1. जब विचाराधीन व्यक्ति की सहमति हो<br>2. जब कानून के साथ सहयोग करने के लिए प्रकटीकरण की आवश्यकता होती है'
          },
          correspond_personal_information: {
            name:'व्यक्तिगत जानकारी के उपयोग का प्रकटीकरण, सुधार, जोड़, हटाना और निलंबन',
            description: 'प्रकटीकरण, सुधार, जोड़, हटाने और संबंधित व्यक्ति के व्यक्तिगत डेटा के उपयोग के निलंबन के मामले में, हम पुष्टि करेंगे कि यह प्रश्न में व्यक्ति है, और हम तुरंत पत्र-व्यवहार करेंगे।'
          },
          children: {
            name:'संतान',
            description: 'यह साइट सेवा 16 साल से कम उम्र के बच्चों के लिए अभिप्रेत नहीं है, और हम जानबूझकर 16 साल से कम उम्र के बच्चों से जानकारी एकत्र नहीं करते हैं।<br><br>16 वर्ष या उससे कम उम्र के बच्चों को अपने माता-पिता या अभिभावकों की अनुमति के बिना कोई भी व्यक्तिगत जानकारी प्रस्तुत नहीं करनी चाहिए। इस साइट सेवा का उपयोग करके, आप प्रतिनिधित्व कर रहे हैं कि आप कम से कम 18 वर्ष के हैं, या कि आप कम से कम 16 वर्ष के हैं और आपके पास इस सेवा का उपयोग करने के लिए आपके माता-पिता या अभिभावकों की अनुमति है।'
          },
          eu_and_eea_users_rights: {
            name:'यूरोपीय संघ और ईईए उपयोगकर्ताओं के अधिकार',
            description: 'यदि आप आदतन यूरोपीय संघ या यूरोपीय आर्थिक क्षेत्र में रहते हैं, तो आपको अपनी जानकारी तक पहुँचने, उसे सुधारने, डाउनलोड करने या मिटाने का अधिकार है, साथ ही साथ अपनी जानकारी के कुछ प्रसंस्करण पर प्रतिबंध लगाने और आपत्ति करने का अधिकार है। जबकि इनमें से कुछ अधिकार आम तौर पर लागू होते हैं, कुछ अधिकार केवल कुछ सीमित परिस्थितियों में ही लागू होते हैं। हम नीचे इन अधिकारों का वर्णन करते हैं:<br><br>आपके पास अपने व्यक्तिगत डेटा तक पहुंचने का अधिकार है और, यदि आवश्यक हो, तो इसे संशोधित या हटा दिया या प्रतिबंधित कर दिया है।<br>कुछ मामलों में आपको अपने डेटा की पोर्टेबिलिटी का अधिकार हो सकता है। डेटा।<br>जब हम प्रत्यक्ष विपणन उद्देश्यों के लिए प्रोफाइलिंग करते हैं तो आप हमें मार्केटिंग संचार नहीं भेजने और अपने व्यक्तिगत डेटा का उपयोग नहीं करने के लिए भी कह सकते हैं।<br>आप निम्नलिखित का पालन करके ईमेल न्यूज़लेटर्स और अन्य मार्केटिंग संचार प्राप्त करने से ऑप्ट आउट कर सकते हैं। उन ईमेल में आपको दिए गए ऑप्ट-आउट निर्देश।<br>यदि आप मार्केटिंग संचार से ऑप्ट-आउट करते हैं तो लेन-देन संबंधी खाता संदेश अप्रभावित रहेंगे।'
          },
          california_privacy_rights: {
            name:'कैलिफ़ोर्निया उपयोगकर्ता अधिकार',
            description: 'कैलिफ़ोर्निया निवासी जो व्यक्तिगत, पारिवारिक या घरेलू उपयोग के लिए उत्पाद या सेवाएं प्राप्त करने में व्यक्तिगत जानकारी प्रदान करते हैं, वे हमसे अनुरोध करने और प्राप्त करने के हकदार हैं, प्रति कैलेंडर वर्ष में एक बार, हमारे द्वारा साझा की गई ग्राहक जानकारी के बारे में जानकारी, यदि कोई हो, अन्य व्यवसायों के साथ अपने स्वयं के प्रत्यक्ष के लिए विपणन उपयोग करता है।<br>यदि लागू हो, तो इस जानकारी में ग्राहक जानकारी की श्रेणियां और उन व्यवसायों के नाम और पते शामिल होंगे जिनके साथ हमने तत्काल पहले कैलेंडर वर्ष के लिए ग्राहक जानकारी साझा की थी।<br>यह जानकारी प्राप्त करने के लिए, कृपया हमें ईमेल करें info@ezeful.app.com पर विषय पंक्ति "कैलिफ़ोर्निया गोपनीयता जानकारी के लिए अनुरोध" के साथ; हम आपको एक उत्तर ई-मेल भेजेंगे जिसमें अनुरोधित जानकारी होगी।<br>सभी जानकारी साझाकरण कैलिफ़ोर्निया "शाइन द लाइट" आवश्यकताओं के अंतर्गत नहीं आता है और केवल कवर किए गए साझाकरण की जानकारी हमारे जवाब में शामिल की जाएगी।'
          },
          disclaimer: {
            name:'अस्वीकरण',
            description: 'कृपया समझें कि इस साइट पर पोस्ट की गई सामग्री से होने वाले किसी भी नुकसान के लिए हम जिम्मेदार नहीं हैं।'
          },
          changes_privacy_policy: {
            name:'गोपनीयता नीति में परिवर्तन',
            description: 'यह साइट व्यक्तिगत जानकारी पर लागू संयुक्त राज्य अमेरिका और जापान के कानूनों का अनुपालन करती है और उपयुक्त के रूप में इस नीति की सामग्री की समीक्षा और सुधार करने का प्रयास करती है।<br><br>इस पृष्ठ पर हमेशा अद्यतन गोपनीयता नीति का खुलासा किया जाएगा।'
          },
          last_updated: {
            name: 'आखरी अपडेट',
            description: '21 जनवरी 2022',
          }
        }
      },
      audio_converter: {
        name: 'ऑडियो कनवर्टर',
        meta_description: 'ऑडियो कनवर्टर आपके ब्राउज़र में विभिन्न ऑडियो और वीडियो फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        detailed_description: 'ऑडियो कनवर्टर आपके ब्राउज़र में विभिन्न ऑडियो (mp3, wav, aac, ogg, m4a, m4r, flac, opus, aiff) और वीडियो (mp4, avi, mpg, mov, flv, 3gp, webm, mkv) फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        label: {
          audio_setting: 'ऑडियो सेटिंग',
        }
      },
      video_converter: {
        name: 'वीडियो कनवर्टर',
        meta_description: 'वीडियो कनवर्टर आपके ब्राउज़र से विभिन्न वीडियो फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        detailed_description: 'वीडियो कनवर्टर आपके ब्राउज़र से विभिन्न वीडियो (mp4, avi, mpg, mov, flv, 3gp, webm, mkv) फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        label: {
          video_setting: 'वीडियो सेटिंग',
          audio_setting: 'ऑडियो सेटिंग',
        }
      },
      image_converter: {
        name: 'छवि कनवर्टर',
        meta_description: 'छवि कनवर्टर आपके ब्राउज़र के साथ विभिन्न छवि फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        detailed_description: 'छवि कनवर्टर आपके ब्राउज़र के साथ विभिन्न छवि (png, jpeg, gif, webp) फ़ाइलों को मुफ्त में परिवर्तित कर सकता है।',
        label: {
          effect_default: 'डिफ़ॉल्ट पर लौटें',
          effect_grayscale: 'ग्रेस्केल',
          effect_threshold: 'थ्रेशोल्डिंग',
          effect_invert: 'उलटा',
          effect_gamma: 'गामा सुधार',
        }
      },
      regex_tester: {
        name: 'रेगेक्स परीक्षक',
        meta_description: 'रेगेक्स परीक्षक नियमित अभिव्यक्तियों का परीक्षण करना आसान बनाता है।',
        detailed_description: 'रेगेक्स परीक्षक नियमित अभिव्यक्तियों का परीक्षण करना आसान बनाता है।',
        label: {
          reference: 'संदर्भ (MDN वेब डॉक्स)',
          flag: 'खण्ड',
          character_classes: 'चरित्र वर्ग',
          assertions: 'अभिकथन',
          groups_and_ranges: 'समूह और रेंज',
          quantifiers: 'परिमाणकों',
          result_unique: 'डुप्लिकेट हटाएं और प्रदर्शित करें।',
          result_duplicate_only: 'केवल डुप्लिकेट दिखाएं।',
          result_duplicate_unique: 'केवल डुप्लीकेट अद्वितीय और प्रदर्शित होते हैं।',
          result_all: 'सब दिखाओ।',
          output: {
            match: 'मिलान',
            group: 'समूह'
          }
        },
        url: {
          flag: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#advanced_searching_with_flags',
          character_classes: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Character_Classes#types',
          assertions: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Assertions#types',
          groups_and_ranges: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Groups_and_Ranges#types',
          quantifiers: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Quantifiers#types',
        },
      },
      //encode_tools: {
      //  name: 'एनकोड टूल्स',
      //  meta_description: '',
      //  detailed_description: '',
      //},
      yaml_tools: {
        name: 'YAML उपकरण',
        meta_description: 'YAML उपकरण YAML डेटा को JSON / TOML / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
        detailed_description: 'YAML उपकरण YAML डेटा को JSON / TOML / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
      },
      json_tools: {
        name: 'JSON उपकरण',
        meta_description: 'JSON उपकरण JSON डेटा को YAML / TOML / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
        detailed_description: 'JSON उपकरण JSON डेटा को YAML / TOML / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
      },
      toml_tools: {
        name: 'TOML उपकरण',
        meta_description: 'TOML उपकरण TOML डेटा को YAML / JSON / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
        detailed_description: 'TOML उपकरण TOML डेटा को YAML / JSON / XML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
      },
      xml_tools: {
        name: 'XML उपकरण',
        meta_description: 'XML उपकरण XML डेटा को YAML / JSON / TOML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
        detailed_description: 'XML उपकरण XML डेटा को YAML / JSON / TOML प्रारूप में प्रारूपित, संपीड़ित और परिवर्तित कर सकते हैं।',
      },
      //csv_tools: {
      //  name: 'CSV उपकरण',
      //  meta_description: '',
      //  detailed_description: '',
      //},
      uuid_generator: {
        name: 'UUID जनरेटर',
        meta_description: 'UUID जनरेटर सामूहिक रूप से UUID / GUID संस्करण 4 के अनुसार अद्वितीय आईडी उत्पन्न कर सकता है।',
        detailed_description: 'UUID जनरेटर सामूहिक रूप से UUID / GUID संस्करण 4 के अनुसार अद्वितीय आईडी उत्पन्न कर सकता है।',
      },
    },
  }
}
